import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useStats } from '../contexts/StatsContext';

const StatsSection = () => {
  const { language } = useLanguage();
  const { googleReviews } = useStats();

  const stats = [
    { value: `${googleReviews}+`, label: { de: 'Google Bewertungen', en: 'Google Reviews' } },
    { value: '5.0', label: { de: 'Sterne Durchschnitt', en: 'Star Average' } },
    { value: '100%', label: { de: 'Hohe Teilnahmequote', en: 'High Participation Rate' } },
    { value: '100%', label: { de: 'Erfolgsquote', en: 'Success Rate' } },
  ];

  return (
    <section className="py-16 bg-red-600">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="stat-item text-center opacity-0 animate-fadeIn"
              style={{ animationDelay: `${index * 0.15}s`, animationFillMode: 'forwards' }}
            >
              <p className="text-4xl md:text-5xl font-extrabold text-white mb-2">
                {stat.value}
              </p>
              <p className="text-red-100 text-sm md:text-base font-medium">
                {stat.label[language]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
